import CategoriaContainer from './CategoriaContainer';
export default CategoriaContainer;